__turbopack_context__.v({
  "root": "BrowseTabs-module-scss-module__NcmlGq__root",
  "tab": "BrowseTabs-module-scss-module__NcmlGq__tab",
});
